import initialState from 'src/constants/initialState';

function migrateCleanState() {
  return { ...initialState } as any;
}

export default migrateCleanState;
